import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
	path: '/student_manage',
	name: 'StudentManage',
	meta: {
		title: '学员管理',
		keepAlive: false
	},
	component: Layout,
	redirect: '/student_manage/student_list',
	children: [
		{
			path: 'student_list',
			name: 'StudentList',
			meta: {
				title: '学员列表',
				keepAlive: false
			},
			component: resolve => require(['@/views/studentMangage/studentList/Index.vue'], resolve),
		},
		{
			path: 'data_report',
			name: 'DataReport',
			meta: {
				title: '数据导出',
				keepAlive: false
			},
			component: resolve => require(['@/views/studentMangage/dataReport/Index.vue'], resolve),
		},
		{
			path: 'student_list',
			name: 'StudentLists',
			meta: {
				title: '学员列表',
				keepAlive: false
			},
			component: resolve => require(['@/views/studentMangage/studentList/Index.vue'], resolve),
		},
		{
			path: 'student_list',
			name: 'StudentListb',
			meta: {
				title: '学员列表',
				keepAlive: false
			},
			component: Empty,
			children: [
				{
					path: 'progress_list',
					name: 'ProgressList',
					meta: {
						title: '学习进度',
						keepAlive: false
					},
					component: resolve => require(['@/views/studentMangage/progressList/Index.vue'], resolve),
				},
				{
					path: 'progress_list',
					name: 'Progress_list',
					meta: {
						title: '学习进度',
						keepAlive: false
					},
					component: Empty,
					children: [{
						path: 'class_progress_list_detail',
						name: 'ProgressListDetail',
						meta: {
							title: '进度详情',
							keepAlive: false
						},
						component: resolve => require(['@/views/studentMangage/common/progressDetail.vue'], resolve)

					}]
				},
			]
		},
		// {
		//   path: 'grouping',
		//   name: 'Grouping',
		//   meta: {
		//     title: '分组',
		//     keepAlive: false
		//   },
		//   component: resolve => require(['@/views/studentMangage/grouping/Index.vue'], resolve),
		// },
	]
}
